module.exports = __webpack_public_path__ + "img/music_009.eb96e8da.png";